"use client";
import { createContext, useContext } from "react";

type LocationBlockedPhrases = {
  title?: string;
  description?: string;
};

type Props = {
  value: LocationBlockedPhrases;
};

const LocationBlockedPhrasesContext = createContext<LocationBlockedPhrases>({});

export const useLocationBlockedPhrases = () =>
  useContext(LocationBlockedPhrasesContext);

export const LocationBlockedPhrasesContextProvider: FC<Props> = ({
  value,
  children,
}) => (
  <LocationBlockedPhrasesContext.Provider value={value}>
    {children}
  </LocationBlockedPhrasesContext.Provider>
);
